export default "__VITE_ASSET__6af52850__"